import { useState, useEffect } from "react";
import { auth, db } from "../starsonata/firebase";
import { doc, getDoc } from "firebase/firestore";
import { clearCachedRoster } from "../starsonata/RosterCache";

export default function useUserData() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user && user.emailVerified) {

        clearCachedRoster();
        const docRef = doc(db, "users", user.uid);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          setUserData({ uid: user.uid, ...snap.data() });
        }
      } else {
        setUserData(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return { userData, loading };
}